import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import {
  getAlltarget,
  sendistri,
  sendistriprofinal,
} from "../../actions/users";
import Search from "@material-ui/icons/Search";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import customInputStyle from "assets/jss/material-dashboard-react/components/customInputStyle.js";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import { Link, useHistory, useParams } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import { toastAlert } from "../../lib/toastAlert";
import CardHeader from "components/Card/CardHeader.js";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Card from "components/Card/Card.js";

// function createData(FirstName, lastName, Email, phoneNo, accountType) {
//   return { FirstName, lastName, Email, phoneNo, accountType };
// }

const rows = [
  // getData('')
  //   createData('firstName', 'lastName', 'Email', 'phoneNo', 'accountType')
  //   createData('Donut', 452, 25.0, 51, 4.9),
];

const headCells = [
  { id: "month", numeric: false, disablePadding: true, label: "Month/Year" },

  {
    id: "tc",
    numeric: false,
    disablePadding: true,
    label: "Total Count",
  },

  //   {
  //     id: "dc",
  //     numeric: false,
  //     disablePadding: true,
  //     label: "Direct Count",
  //   },
  //   { id: "ic", numeric: false, disablePadding: true, label: "Indirect Count" },
  {
    id: "sa",
    numeric: false,
    disablePadding: true,
    label: "Staked Amount",
  },
  {
    id: "una",
    numeric: false,
    disablePadding: true,
    label: "Un Staked Amount",
  },
  { id: "Target", numeric: false, disablePadding: true, label: "Target" },

  {
    id: "una",
    numeric: false,
    disablePadding: true,
    label: "Incentive 5(%)",
  },
];

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "center" : "center"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 76%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    ></Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onChangeterm: PropTypes.func.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  flexHeader: {
    display: "flex !important",
    justifyContent: "space-between !important",
    alignItems: "center !important",
  },
  btnPrimary: {
    backgroundColor: "#b462c5",
    color: "#ffffff !important",
    padding: "7px 15px",
    fontSize: "12px",
    fontWeight: "700",
  },
}));

const customStyle = makeStyles(customInputStyle);

export default function EnhancedTable() {
  const classes = useStyles();
  const customStyles = customStyle();
  const history = useHistory();
  const classesSearch = useToolbarStyles();
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(36);
  const [userDetails, setUser] = useState([]);
  const [monthfails, set3monthfails] = useState();
  const [alldata, setallData] = useState();
  const { id, pid } = useParams();
  const [Stakereached, setStakereached] = useState();

  const handleRequestSort = (event, property) => {};

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  useEffect(() => {
    setTimeout(() => {
      getAll();
    }, 500);
  }, [id]);
  const getAll = async (search = {}) => {
    let filterData = search;
    if (filterData.search == "") {
      filterData = {};
    }

    var res = await getAlltarget({ promId: id });
    console.log(
      "result=================dddddddddddddddddddddddddddddddddddd==",
      res
    );
    if (res && res.result) {
      console.log("result===================", res.result.data.failscount);
      setUser(res.result.data);
      set3monthfails(res.failscount);
      setallData(res.alldata);
    }
    setStakereached(res.stakereached);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const sendDistribute = async (mainid, id) => {
    if (window.confirm("Are you sure want to update this promotor?") == true) {
      var res = await sendistri({ mainid: mainid, id: id });
      // console.log(res, "----747474");
      toastAlert("success", res.message, "address");
      getAll();
      // console.log(id, "idddd------", mainid, "-mainid----");
    }
  };

  const sendfinalDistribute = async (mainid) => {
    if (window.confirm("Are you sure want to update this promotor?") == true) {
      var res = await sendistriprofinal({ mainid: mainid });
      // console.log(res, "----747474");
      toastAlert("success", res.message, "address");
      getAll();
      // console.log(id, "idddd------", mainid, "-mainid----");
    }
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Toolbar
          className={clsx(classesSearch.root, {
            [classesSearch.highlight]: selected.length > 0,
          })}
        >
          <div className={classes.flexHeader}>
            <Link to={"/promotors/" + pid} className={classes.btnPrimary}>
              Back
            </Link>
          </div>
        </Toolbar>
        {monthfails == "Arrived" && (
          <div>
            &nbsp;&nbsp; Note :
            <span style={{ color: "red" }}>
              {" "}
              3 Month's Failure : {monthfails}
            </span>
          </div>
        )}
        <div>
          <span style={{ color: "green" }}>
            {" "}
            &nbsp;&nbsp; Promotor Address : {alldata?.Address}
          </span>
        </div>

        <div>
          <span style={{ color: "green" }}>
            {" "}
            &nbsp;&nbsp; Kyc Status : {alldata?.kycstatus}
          </span>
        </div>

        <div>
          <span style={{ color: "green" }}>
            {" "}
            &nbsp;&nbsp; Final Settlement : {alldata?.distributionstatus}
          </span>
        </div>

        <div>
          <span style={{ color: "green" }}>
            {" "}
            &nbsp;&nbsp; Total Stake Amount : {Stakereached?.totalstakeAmount}
          </span>
        </div>

        <div>
          <span style={{ color: "green" }}>
            {" "}
            &nbsp;&nbsp; Acheived Stake Amount :{" "}
            {Stakereached?.acheivedstakeAmount}
          </span>
        </div>

        <div>
          <span style={{ color: "green" }}>
            {" "}
            &nbsp;&nbsp; Remaining Stake Amount :{" "}
            {Number(Stakereached?.totalstakeAmount) -
              Number(Stakereached?.acheivedstakeAmount)}
          </span>
        </div>

        {alldata?.kycstatus == "approved" &&
          alldata?.distributionstatus != "settled" && (
            <Toolbar
              className={clsx(classesSearch.root, {
                [classesSearch.highlight]: selected.length > 0,
              })}
            >
              <div className={classes.flexHeader}>
                {" "}
                <Link
                  className={classes.btnPrimary}
                  onClick={(e) => sendfinalDistribute(alldata?._id)}
                >
                  Send Final Distribution
                </Link>
              </div>
            </Toolbar>
          )}

        <Card>
          <CardHeader color="primary">
            <div className={classes.flexHeader}>
              <h4 className={classes.cardTitleWhite}>Promotors Target List</h4>
            </div>
          </CardHeader>
          <br />
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              // size={dense ? 'small' : 'medium'}
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                classes={classes}
                numSelected={selected.length}
                //   order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              <TableBody>
                {userDetails &&
                  userDetails
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      let incentive =
                        ((row.stakedAmount - row.unstakedAmount) * 5) / 100;
                      // const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <TableRow>
                          <TableCell align="center">{row.month}</TableCell>
                          <TableCell align="center">{row.headscount}</TableCell>
                          {/* <TableCell align="center">
                            {row.headscount - row.indirectheadscount}
                          </TableCell>
                          <TableCell align="center">
                            {row.indirectheadscount}
                          </TableCell> */}
                          <TableCell align="center">
                            {row.stakedAmount}
                          </TableCell>
                          <TableCell align="center">
                            {row.unstakedAmount}
                          </TableCell>

                          <TableCell align="center">
                            {row.status == "Achieved" && (
                              <span style={{ color: "green" }}>Achieved</span>
                            )}
                          </TableCell>

                          <TableCell align="center">
                            {row.status == "Achieved" && incentive}
                            <div>{""}</div>
                            <div>
                              {row.status == "Achieved" &&
                                row.distributionstatus == "settled" &&
                                "Settled"}
                              {row.status == "Achieved" &&
                                row.distributionstatus != "settled" && (
                                  <Link
                                    className={classes.btnPrimary}
                                    onClick={(e) =>
                                      sendDistribute(alldata?._id, row._id)
                                    }
                                  >
                                    Send Distribution
                                  </Link>
                                )}
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={userDetails && userDetails.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Card>
      </Paper>
    </div>
  );
}
